import { render, staticRenderFns } from "./AddConsumables.vue?vue&type=template&id=48b16278&scoped=true"
import script from "./AddConsumables.vue?vue&type=script&lang=js"
export * from "./AddConsumables.vue?vue&type=script&lang=js"
import style0 from "./AddConsumables.vue?vue&type=style&index=0&id=48b16278&prod&scoped=true&lang=css"
import style1 from "./AddConsumables.vue?vue&type=style&index=1&id=48b16278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b16278",
  null
  
)

export default component.exports